import { InputAdornment, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { EEstimateActionType } from "store/reducers/EstimateReducer";
import useSalesEstimate from "views/Estimates/EstimatesHooks/useSalesEstimate";

export const isNumberOrComma = (value: string) => {
    const numberRegex = new RegExp(/^[\d\,]+$/gm);
    // const dollarAmountRegex = new RegExp(/^\d+$/gm);
    return numberRegex.test(value) || value.length === 0
}


export const UserCountInput = (props: { disabled: boolean, onChange: Function }) => {
    const salesEstimateReducer = useSalesEstimate()
    const { stateEstimate, dispatchEstimate, isAPILoading, error } = salesEstimateReducer
    const [isFocused, setIsFocused] = useState(false);
    const [userCount, setUserCount] = useState<string>(stateEstimate.estimate.hsl_CustomerUserCount?.toLocaleString('en-US') || '0');

    return (
        <>
            <TextField
                disabled={props.disabled}
                value={userCount || '0'}
                variant="standard"
                sx={{
                    width: '80%',
                }}
                inputProps={{
                    style: {
                        fontSize: 14,
                        paddingLeft: 0,
                    },
                }}
                onChange={(event) => {
                    // setShowCostError(false)
                    const value = Number(event.target.value.replaceAll(',', ''))?.toLocaleString()
                    if (isNumberOrComma(value)) {
                        setUserCount(value)
                        props.onChange()
                    }
                }}
                onBlur={(event) => {
                    // setShowCostError(false)
                    const value = event.target.value.replaceAll(',', '')
                    if (isNumberOrComma(value)) {
                        dispatchEstimate({
                            type: EEstimateActionType.estimate_update,
                            estimate: { hsl_CustomerUserCount: Number(value) }
                        })
                    }
                    setIsFocused(false)
                }
                }
            />
        </>
    )
}